module.exports = __webpack_public_path__ + "img/dataroom.629eef70.png";